
import Vue, { VueConstructor } from "vue";
import { warn } from "@/utils";
import store from "@/store";

// All widget imports
import {
  Form,
  Alert,
  Banner,
  Heading,
  Image,
  Text,
  Input,
  Email,
  Phone,
  Lookup,
  Checkbox,
  CheckboxGroup,
  CheckboxPhone,
  CheckboxContact,
  Radio,
  RadioGroup,
  Button,
  Select,
  SignaturePad,
  TextArea,
  Page,
  Group,
  Card,
  Modal,
  Flex,
  Grid,
  Row,
  Col,
  Break,
  Copyright,
  Invitation,
  Language,
  CheckIn
} from "@/components/widgets";

// Widget Component map
const components: Record<string, VueConstructor> = {
  "w-form": Form,
  "w-alert": Alert,
  "w-banner": Banner,
  "w-heading": Heading,
  "w-image": Image,
  "w-text": Text,
  "w-input": Input,
  "w-email": Email,
  "w-phone": Phone,
  "w-lookup": Lookup,
  "w-checkbox": Checkbox,
  "w-checkbox-group": CheckboxGroup,
  "w-checkbox-phone": CheckboxPhone,
  "w-checkbox-contact": CheckboxContact,
  "w-radio": Radio,
  "w-radio-group": RadioGroup,
  "w-button": Button,
  "w-select": Select,
  "w-signature-pad": SignaturePad,
  "w-textarea": TextArea,
  "w-page": Page,
  "w-group": Group,
  "w-card": Card,
  "w-break": Break,
  "w-modal": Modal,
  "w-flex": Flex,
  "w-grid": Grid,
  "w-row": Row,
  "w-col": Col,
  "w-copyright": Copyright,
  "w-invitation": Invitation,
  "w-language": Language,
  "w-check-in": CheckIn
};

export interface Event {
  target: string;
  event: string;
}

export interface WidgetProps {
  id: string;
  type: string;
  enabled: boolean;
  props: any;
  name?: string;
  children?: WidgetProps[];
  on?: Record<string, Event[]>;
  validators?: Array<string | { name: string; args?: any }>;
}

export default Vue.extend<WidgetProps>({
  functional: true,
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    props: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String
      // default: undefined
    },
    children: {
      type: Array
      // default: undefined
    },
    on: {
      type: Object
      // default: undefined
    },
    validators: {
      type: Array
    }
  },
  render(h, context) {
    const { type, enabled, children, props, ...rest } = context.props;
    let computedChildren;
    if (children) {
      computedChildren = children.map(id => {
        const widget = store.getters["form/getWidgetById"](id);
        if (process.env.NODE_ENV !== "production" && widget == null) {
          warn(`Missing widget with id: "${id}".`);
        }
        return widget;
      });
    }
    return enabled
      ? h(components[`w-${type}`], {
          props: {
            ...props,
            ...rest,
            children: computedChildren
          }
        })
      : [];
  }
});
